<script lang="ts">
	import HomeListsController from '../components/Lists/HomeListsController.svelte';
	import DevicesListHolder from '../components/Lists/Devices/DevicesListHolder.svelte';
	import RoomsListHolder from '../components/Lists/Rooms/RoomsListHolder.svelte';
	import GroupsListHolder from '../components/Lists/Groups/GroupsListHolder.svelte';
	import ScenesListHolder from '../components/Lists/Scenes/ScenesListHolder.svelte';
	import AlarmsListHolder from '../components/Lists/Alarms/AlarmsListHolder.svelte';
	import ThermostatsListHolder from '../components/Lists/Thermostats/ThermostatsListHolder.svelte';
	import DeviceRouteHandler from '../components/DeviceRouteHandler.svelte';

	export let params = { type: '', id: '', device_id: '', room_list: '' };

	// force route to a particular device room and open drawer to device from url params

	const listComponentsMap = {
		device: DeviceRouteHandler,
		devices: DevicesListHolder,
		rooms: RoomsListHolder,
		groups: GroupsListHolder,
		scenes: ScenesListHolder,
		room: DevicesListHolder,
		group: DevicesListHolder,
		alarms: AlarmsListHolder,
		thermostats: ThermostatsListHolder,
	};

	$: component =
		params.type === 'room' ? listComponentsMap[params.room_list] : listComponentsMap[params.type];

	//TODO check does it works correctly
	// onMount(() => {
	// 	drawerState.set({
	// 		...$drawerState,
	// 		type: params.type,
	// 		id: params.id || '-1'
	// 	});
	// });
</script>

<!-- handle for the special device route -->
{#if params.type !== 'device'}
	<HomeListsController type={params.type} type_id={params.id} room_list={params.room_list} let:list>
		<svelte:component this={component} {list} type={params.type} id={params.id} />
	</HomeListsController>
{/if}
